<template>
  <div>
    <div>
      <topbar
        :titulo="$t('ACADEMICO_MATRICULAS.MATRICULAS')"
        :subtitulo="$t('ACADEMICO_MATRICULAS.MATRICULAS_DESCRICAO_PAGE')"
        :breadcrumbs="breadcrumbs"
      >
        <template #header>
          <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 ml-md-4"
          >
            <b-button
              variant="info"
              class="text-nowrap"
              @click="irPara('nova-matricula')"
              v-if="podeCadastrar"
            >
              {{ $t('ACADEMICO_MATRICULAS.NOVA_MATRICULA') }}
            </b-button>
            <b-button
              variant="info"
              class="text-nowrap"
              @click="irPara('nova-pessoa', '', 'matriculas')"
              v-if="verificarPermissao('Pessoa', 'Criar')"
            >
              {{ $t('ACADEMICO_MATRICULAS.NOVA_PESSOA') }}
            </b-button>
          </div>
        </template>
      </topbar>

      <div class="w-100">
        <div class="row mb-3">
          <div class="col-12 col-md-3">
            <input-text
              ref="filtroMatricula"
              v-model="filtro.nomeAlunoCodigoMatricula"
              :label="$t('ACADEMICO_MATRICULAS.FILTRO_LABEL')"
              :placeholder="$t('ACADEMICO_MATRICULAS.FILTRO_PLACEHOLDER')"
              @enter="buscar"
            />
          </div>

          <div class="col-12 col-md-3">
            <input-text
              ref="filtroMatricula"
              v-model="filtro.nomeEmVinculos"
              :label="$t('ACADEMICO_MATRICULAS.NOME_VINCULO')"
              :placeholder="$t('ACADEMICO_MATRICULAS.NOME_VINCULO_PLACEHOLDER')"
              @enter="buscar"
            />
          </div>

          <div class="col-12 col-md-3">
            <input-select-search
              ref="statusMatricula"
              :label="$t('ACADEMICO.STATUS_MATRICULA')"
              v-model="filtro.statusMatricula"
              @setChanged="buscar"
              :options="listaStatusMatricula"
            />
          </div>
          <div class="col-12 col-md-3 botao-acao-filtro">
            <b-button variant="primary" class="mr-2" @click="buscar">
              {{ $t('GERAL.BUSCAR') }}
            </b-button>
          </div>
        </div>
      </div>

      <b-table
        :empty-text="$t('ACADEMICO_MATRICULAS.NENHUM_MATRICULA_REGISTRADA')"
        head-variant="light"
        :items="items"
        :fields="fields"
        show-empty
        stacked="md"
        hover
        v-if="podeVisualizar"
        @sort-changed="aoMudarOrdenacao"
      >
        <template #cell(acoes)="item">
          <div class="flex" v-if="mostrarAcoes">
            <b-dropdown variant="outline-default" class="tamanho">
              <b-dropdown-item
                @click="editar(item.item.id)"
                v-if="podeEditar && item.item.status == 'Ativo'"
              >
                {{ $t('GERAL.EDITAR') }}
              </b-dropdown-item>
              <b-dropdown-item
                @click="ativarMatricula(item.item)"
                v-if="podeExcluir && item.item.status == 'Inativo'"
              >
                {{ $t('GERAL.ATIVAR') }}
              </b-dropdown-item>
              <b-dropdown-item
                @click="inativarMatricula(item.item)"
                v-if="podeExcluir && item.item.status == 'Ativo'"
              >
                {{ $t('GERAL.INATIVAR') }}
              </b-dropdown-item>
              <b-dropdown-item
                @click="visualizar(item.item.id)"
                v-if="podeVisualizar"
              >
                {{ $t('GERAL.VISUALIZAR') }}
              </b-dropdown-item>

              <!-- Relatórios -->
              <b-dropdown-item
                v-if="podeEditar"
                @click="
                  abrirModalPdfs({
                    ...item.item,
                    documentoCodigo: 3,
                    nomeRelatorio: $t(
                      'ACADEMICO_MATRICULAS.IMPRIMIR_ATESTADO_FREQUENCIA'
                    ),
                  })
                "
              >
                {{ $t('ACADEMICO_MATRICULAS.IMPRIMIR_ATESTADO_FREQUENCIA') }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="podeEditar"
                @click="abrirModalImprimirBoletimENotasParciais(item.item)"
              >
                {{ $t('ACADEMICO_MATRICULAS.IMPRIMIR_BOLETIM_NOTAS_PARCIAIS') }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="podeEditar"
                @click="abrirModalImprimirHistorico(item.item)"
              >
                {{ $t('ACADEMICO_MATRICULAS.IMPRIMIR_HISTORICO_ESCOLAR') }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="podeEditar"
                @click="abrirModalImprimirCertificado(item.item)"
              >
                {{ $t('ACADEMICO_MATRICULAS.IMPRIMIR_CERTIFICADO') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </b-table>
    </div>

    <paginacao v-model="paginacao" :total="paginacao.total" @input="buscar" />

    <modal-imprimir-relatorios
      :exibir="modais.exibirBaixarPdfs"
      :item="modais.baixarPdf"
      @fechar="fecharModalPfs"
    />

    <modal-imprimir-boletim
      :exibir="modais.exibirImprimirBoletim"
      :item="modais.dadosBoletim"
      @fechar="fecharModalImprimirBoletimENotasParciais"
    />

    <modal-imprimir-historico
      :exibir="modais.exibirImprimirHistorico"
      :item="modais.historicoDadosAluno"
      @fechar="fecharModalImprimirHistorico"
    />

    <modal-imprimir-certificado
      :exibir="modais.exibirImprimirCertificado"
      :item="modais.certificadoDadosAluno"
      @fechar="fecharModalImprimirCertificado"
    />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import rotas from '@/common/utils/rotas';
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';
import helpers from '@/common/utils/helpers';

// Services:
import MatriculaServices from '@/common/services/matriculas/matriculas.service';
import Permissoes from '@/components/mixins/permissoes';
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service.js';

// Components:
import Paginacao from '@/components/paginacao/Paginacao';
import { InputSelectSearch, InputText } from '@/components/inputs/index';
import ModalImprimirRelatorios from '@/views/academico/matriculas/components/ModalImprimirRelatorios.vue';
import ModalImprimirBoletim from '@/views/academico/matriculas/components/ModalImprimirBoletim.vue';
import ModalImprimirHistorico from '@/views/academico/matriculas/components/ModalImprimirHistorico.vue';
import ModalImprimirCertificado from '@/views/academico/matriculas/components/ModalImprimirCertificado.vue';

export default {
  mixins: [Permissoes],
  components: {
    InputSelectSearch,
    InputText,
    Paginacao,
    Topbar,
    ModalImprimirRelatorios,
    ModalImprimirBoletim,
    ModalImprimirHistorico,
    ModalImprimirCertificado,
  },
  computed: {
    mostrarAcoes() {
      return this.podeEditar || this.podeExcluir || this.podeVisualizar;
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'codigoMatricula',
          label: this.$t('ACADEMICO_MATRICULAS.CODIGO_MATRICULA'),
          sortable: true,
        },
        {
          key: 'nome',
          label: this.$t('ACADEMICO_MATRICULAS.ALUNO'),
          sortable: true,
        },
        {
          key: 'status',
          label: this.$t('ACADEMICO_MATRICULAS.STATUS'),
          sortable: true,
        },
        {
          key: 'observacao',
          label: this.$t('ACADEMICO_MATRICULAS.OBSERVACAO'),
          formatter: (value) => {
            return value ? `${value?.substring(0, 25)}...` : '-';
          },
        },
        {
          key: 'acoes',
          label: this.$t('ACADEMICO_MATRICULAS.ACOES'),
        },
      ],
      items: [],
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO.ACADEMICO') },
        { titulo: this.$t('ACADEMICO_MATRICULAS.MATRICULAS') },
      ],
      campoOrdenado: null,
      ordem: false,
      listaStatusMatricula: [],
      filtro: {
        nomeAlunoCodigoMatricula: null,
        statusMatricula: null,
      },
      modais: {
        exibirImprimirBoletim: false,
        exibirBaixarPdfs: false,
        baixarPdf: {},
        exibirImprimirHistorico: false,
        historicoDadosAluno: {},
        exibirImprimirCertificado: false,
        certificadoDadosAluno: {},
        dadosBoletim: {},
      },
    };
  },
  mounted() {
    this.buscar();
    this.listarStatusMatricula();
  },
  methods: {
    buscar() {
      this.$store.dispatch(START_LOADING);
      MatriculaServices.obterMatriculasPorFiltroPaginado(
        this.filtro,
        this.paginacao,
        this.campoOrdenado,
        this.ordem
      )
        .then(({ data }) => {
          this.items = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    listarStatusMatricula() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('status-matricula')
        .then(({ data }) => {
          this.listaStatusMatricula = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    ativarMatricula(item) {
      mensagem
        .confirmacao(
          null,
          this.$t('ACADEMICO_MATRICULAS.CONFIRMAR_ATIVACAO').formatUnicorn({
            pessoa: item.nome,
          })
        )
        .then(async (result) => {
          if (result.value) {
            this.$store.dispatch(START_LOADING);
            MatriculaServices.ativar(item.id)
              .then(() => {
                mensagem.sucesso(
                  this.$t('GERAL.SUCESSO'),
                  this.$t('ACADEMICO_MATRICULAS.MATRICULA_ATIVADA')
                );
                this.buscar();
              })
              .catch((err) => {
                mensagem.showErrors(err);
              })
              .finally(() => {
                this.$store.dispatch(STOP_LOADING);
              });
          }
        });
    },
    inativarMatricula(item) {
      mensagem
        .confirmacao(
          null,
          this.$t('ACADEMICO_MATRICULAS.CONFIRMAR_INATIVACAO').formatUnicorn({
            pessoa: item.nome,
          })
        )
        .then(async (result) => {
          if (result.value) {
            this.$store.dispatch(START_LOADING);
            await MatriculaServices.inativar(item.id)
              .then(() => {
                mensagem.sucesso(
                  this.$t('GERAL.SUCESSO'),
                  this.$t('ACADEMICO_MATRICULAS.MATRICULA_INATIVADA')
                );
                this.buscar();
              })
              .catch((err) => {
                mensagem.showErrors(err);
              })
              .finally(() => {
                this.$store.dispatch(STOP_LOADING);
              });
          }
        });
    },
    editar(matriculaId) {
      this.$router.push({
        name: 'editar-matricula',
        params: { id: matriculaId },
      });
    },

    visualizar(matriculaId) {
      this.$router.push({
        name: 'visualizar-matricula',
        params: { id: matriculaId },
      });
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      this.campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy);
      this.ordem = !sortDesc;
      this.buscar();
    },

    abrirModalPdfs(item) {
      this.modais.exibirBaixarPdfs = true;
      this.modais.baixarPdf = item;
    },

    fecharModalPfs() {
      this.modais.exibirBaixarPdfs = false;
      this.modais.baixarPdf = {};
    },

    abrirModalImprimirBoletimENotasParciais(item) {
      this.modais.exibirImprimirBoletim = true;
      this.modais.dadosBoletim = item;
    },

    fecharModalImprimirBoletimENotasParciais() {
      this.modais.exibirImprimirBoletim = false;
      this.modais.dadosBoletim = {};
    },

    abrirModalImprimirHistorico(item) {
      this.modais.exibirImprimirHistorico = true;
      this.modais.historicoDadosAluno = item;
    },

    fecharModalImprimirHistorico() {
      this.modais.exibirImprimirHistorico = false;
      this.modais.historicoDadosAluno = {};
    },

    abrirModalImprimirCertificado(item) {
      this.modais.exibirImprimirCertificado = true;
      this.modais.certificadoDadosAluno = item;
    },

    fecharModalImprimirCertificado() {
      this.modais.exibirImprimirCertificado = false;
      this.modais.historicoDadosAluno = {};
    },
    irPara(rota, id, linkRetornar) {
      rotas.irPara(rota, id, linkRetornar);
    },
  },
};
</script>

<style>
.gap-2 {
  gap: 10px;
}
</style>
